import React from 'react';
import dayjs from 'dayjs';

import { useZone } from 'store/apis';
import { BasicSelector, BasicSelectorProps } from './basic-selector';

type ScheduleSelectorProps = BasicSelectorProps & {
  zoneId: number | null;
  value: number | null;
  onChange?: (value: number | null) => void;
};

export const ScheduleSelector = ({ zoneId, onChange: _onChange = () => {}, value, ...rest }: ScheduleSelectorProps) => {
  const { data: zone, isFetching } = useZone({ zoneId: zoneId as number });
  const { schedule: schedules = [] } = zone;
  const label = 'Schedule';
  const placeholder = 'Select a Schedule...';

  const options = schedules.map(({ id }) => id);
  const getOptionLabel = (option: number) => {
    const { time = '' } = schedules.find(({ id }) => id === option) || {};

    if (!time) {
      return '';
    }

    return dayjs(time, 'HH:mm:ss').format('hh:mm A');
  };
  const onChange: any = (_: any, value: number) => _onChange(value);

  const componentProps: Partial<ScheduleSelectorProps> = {
    label,
    placeholder,
    value,
    options,
    getOptionLabel,
    onChange,
    optionsConfig: false,
    loading: isFetching,
    optionsLoadingText: 'Loading schedules...',
    noOptionsText: 'No schedule',
  };

  return <BasicSelector {...componentProps} {...rest} />;
};
